import seasonalFeatured from './seasonalFeatured';

export default seasonalFeatured;
